import { useContext, createContext } from "react";

export const PrefetchContext = createContext<
  Record<
    string,
    {
      url: string;
      content: string;
    }
  >
>({});

export const useContent = (name: string): string | undefined => {
  const prefetchedData = useContext(PrefetchContext);
  if (!prefetchedData?.[name]?.content) return undefined;

  return Buffer.from(prefetchedData[name].content, "base64").toString("binary");
};
